var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgColAudioPlayLg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 29,
    viewBox: "0 0 4 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.85265 0.666649H1.59982C0.904541 0.666649 0.340904 1.11815 0.340904 1.6751V27.3249C0.340904 27.8819 0.904541 28.3334 1.59982 28.3334H1.85265C2.54793 28.3334 3.11157 27.8819 3.11157 27.3249V1.6751C3.11157 1.11815 2.54793 0.666649 1.85265 0.666649Z",
    fill: "#406EE2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColAudioPlayLg);
export default __webpack_public_path__ + "static/media/col_audio_play_lg.f55949dbb2caef48e3933b5c471304d8.svg";
export { ForwardRef as ReactComponent };